import React, { createContext, useState, useEffect } from 'react';
import assessorApi from '../api/assessorApi';

export const AssessorAuthContext = createContext();

export const AssessorAuthProvider = ({ children }) => {
  const [assessor, setAssessor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('assessorToken');
    if (!token) {
      setLoading(false);
      return;
    }
    assessorApi
      .get('/api/assessor-portal/me')
      .then((res) => setAssessor(res.data))
      .catch(() => localStorage.removeItem('assessorToken'))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, profile) => {
    localStorage.setItem('assessorToken', token);
    setAssessor(profile);
  };

  const logout = () => {
    localStorage.removeItem('assessorToken');
    setAssessor(null);
  };

  return (
    <AssessorAuthContext.Provider value={{ assessor, login, logout, loading, setAssessor }}>
      {children}
    </AssessorAuthContext.Provider>
  );
};
